import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { TextType } from '@amzn/meridian/text/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NOTDISPLAY } from './helper';

interface DisplayTitleProp {
  messageMap: any;
  displaySubtitles: string;
  textSize: TextType;
  maxWidth: string;
}

const DisplayTitle: React.FC<DisplayTitleProp> = ({
  messageMap,
  displaySubtitles,
  textSize,
  maxWidth,
}: DisplayTitleProp): React.ReactElement => {
  const hide = displaySubtitles === NOTDISPLAY;
  return messageMap !== undefined ? (
    <Row spacing='none' spacingInset='none' maxWidth={maxWidth}>
      <Text type={textSize}>
        <FormattedMessage
          id={messageMap.titleMessage.id}
          defaultMessage={messageMap.titleMessage.defaultMessage}
        />
        {!hide && messageMap.subTitleMessage !== undefined ? (
          <>
            {' - '}
            <FormattedMessage
              id={messageMap.subTitleMessage.id}
              defaultMessage={messageMap.subTitleMessage.defaultMessage}
            />
          </>
        ) : (
          <></>
        )}
      </Text>
    </Row>
  ) : (
    <Row />
  );
};

export default DisplayTitle;
